var $questionFull = $('.js-question-full');
var $questionClose = $('.js-question-close');
var $questionPreview = $('.js-question h3');

$questionPreview.on('click', function() {
    var $currentQuestionPreview = $(this).parent();
    var $selectedQuestionFull = $currentQuestionPreview.find('.js-question-full');

    if ($currentQuestionPreview.hasClass('preview--active')) {
        $currentQuestionPreview.removeClass('preview--active');
    } else {
        $questionPreview.each(function() {
            $(this).parent().removeClass('preview--active');
        });

        $currentQuestionPreview.addClass('preview--active');

        window.scrollToObject($currentQuestionPreview);
    }
});

$questionClose.on('click', function() {
    $(this).closest('.js-question').find('h3').trigger('click');
});
